import React from 'react';
import css from '@/css/module/billing.css';
import flex from '@/css/module/flex.css';
import {
  SUBSCRIPTION_TAG,
  subscriptionApi,
  TSubscription,
} from '@/features/subscription/apiSlice';
import UnpaidInvoices from '@/components/billing/stripe/UnpaidInvoices';
import { successMessage } from '@/features/subscription/components/utils';
import { useDispatch } from 'react-redux';

export const Invoices: React.FC<{ subscription: TSubscription }> = ({
  subscription,
}) => {
  const dispatch = useDispatch();

  if (!subscription.outstandingInvoice) {
    return null;
  }

  const onInvoicePaid = () => {
    successMessage('Your payment was successful!');
    dispatch(subscriptionApi.util.invalidateTags([SUBSCRIPTION_TAG]));
  };

  return (
    <div className={css.section}>
      <div className={`${flex.row} ${flex.alignItemsStart}`}>
        <UnpaidInvoices
          stripeKey={subscription.stripeKey}
          outstandingInvoice={subscription.outstandingInvoice}
          onComplete={onInvoicePaid}
        />
      </div>
    </div>
  );
};
